import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface CajaAperturasQuery extends BaseQuery {
    aperturaDesde?: string,
    aperturaHasta?: string,
    cierreDesde?: string,
    cierreHasta?: string
}

export async function getAllCajaActualAperturas(query?: CajaAperturasQuery): Promise<QueryResponse<CajaApertura>> {
    await sleep(1000);
    const response = await api.get("caja_actual/history", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllCajaActualAperturasQuery(query: CajaAperturasQuery = {}, queryConfig: QueryConfig<QueryResponse<CajaApertura>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCajaActualAperturas(query),
        queryKey: ["caja_actual", "history", query],
    })
}

export interface GetAllCajaAperturaQueryProps {
    query?: CajaAperturasQuery,
    queryConfig?: QueryConfig<QueryResponse<CajaApertura>>,
    children: (queryResult: QueryResult<QueryResponse<CajaApertura>>) => ReactNode
}

export function GetAllCajaActualAperturasQuery({
    query,
    queryConfig,
    children
}: GetAllCajaAperturaQueryProps) {
    const queryResult = useGetAllCajaActualAperturasQuery(query, queryConfig);
    return children && children(queryResult);
}